export const HamburgerIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.5 4.58329C2.5 4.35317 2.68655 4.16663 2.91667 4.16663H17.0833C17.3135 4.16663 17.5 4.35317 17.5 4.58329V5.41663C17.5 5.64674 17.3135 5.83329 17.0833 5.83329H2.91667C2.68655 5.83329 2.5 5.64674 2.5 5.41663V4.58329ZM2.5 9.58329C2.5 9.35317 2.68655 9.16663 2.91667 9.16663H17.0833C17.3135 9.16663 17.5 9.35317 17.5 9.58329V10.4166C17.5 10.6467 17.3135 10.8333 17.0833 10.8333H2.91667C2.68655 10.8333 2.5 10.6467 2.5 10.4166V9.58329ZM2.91667 14.1666C2.68655 14.1666 2.5 14.3532 2.5 14.5833V15.4166C2.5 15.6467 2.68655 15.8333 2.91667 15.8333H17.0833C17.3135 15.8333 17.5 15.6467 17.5 15.4166V14.5833C17.5 14.3532 17.3135 14.1666 17.0833 14.1666H2.91667Z"
            />
        </svg>
    );
};
